import Button from '@jetbrains/ring-ui/components/button/button'
import Dialog from '@jetbrains/ring-ui/components/dialog/dialog'
import type {DialogAttrs} from '@jetbrains/ring-ui/components/dialog/dialog'
import {
  ControlsHeight,
  ControlsHeightContext,
} from '@jetbrains/ring-ui/components/global/controls-height'
import Input, {Size} from '@jetbrains/ring-ui/components/input/input'
import {Content, Header} from '@jetbrains/ring-ui/components/island/island'
import Panel from '@jetbrains/ring-ui/components/panel/panel'
import {useState} from 'react'
import type * as React from 'react'

import styles from './ConfirmationDialog.css'

type Props = DialogAttrs & {
  title: string
  children?: React.ReactNode
  onConfirm?: () => void
  onCancel?: () => void
  loader?: boolean
  controlsHeightValue?: ControlsHeight
  referenceValue?: string
  inputPlaceholder?: string
  confirmButtonText?: string
  cancelButtonText?: string
}

function ConfirmationDialog({
  title,
  children,
  onConfirm,
  onCancel,
  loader,
  referenceValue = location.host,
  controlsHeightValue = ControlsHeight.S,
  inputPlaceholder = 'Server hostname',
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  ...restProps
}: Props) {
  const [value, setValue] = useState('')

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onConfirm?.()
  }
  const handleCancel = () => {
    onCancel?.()
    setValue('')
  }

  return (
    <ControlsHeightContext.Provider value={controlsHeightValue}>
      <Dialog onCloseAttempt={handleCancel} trapFocus showCloseButton {...restProps}>
        <Header>{title}</Header>
        <form onSubmit={handleSubmit}>
          <Content>
            {children ?? (
              <div className={styles.confirmationText}>
                <span>{'This action cannot be undone.'}</span>
                <span>
                  {'Please type '}
                  <strong>{referenceValue}</strong>
                  {' to confirm.'}
                </span>
              </div>
            )}
            <Input
              className={styles.input}
              value={value}
              size={Size.FULL}
              autoComplete={'off'}
              placeholder={inputPlaceholder}
              onChange={e => setValue(e.currentTarget.value)}
            />
          </Content>
          <Panel>
            <Button
              type={'submit'}
              disabled={value.trim() !== referenceValue}
              loader={loader}
              primary
            >
              {confirmButtonText}
            </Button>
            <Button onClick={handleCancel}>{cancelButtonText}</Button>
          </Panel>
        </form>
      </Dialog>
    </ControlsHeightContext.Provider>
  )
}

export default ConfirmationDialog
